import { errorMessage } from './lib/utils/messages';

/**
 * Environment variables required for Pras application.
 * They are loaded from env.config.js file from window.env object, so it is possible to replace those variables during deployment time rather than build time.
 */
const envValues = <const>[
  'REACT_APP_GRAPHQL_URI',
  'REACT_APP_OKTA_CLIENT_ID',
  'REACT_APP_OKTA_ISSUER',
  'REACT_APP_LOGOUT_REDIRECT_PREFIX',
  'REACT_APP_PRAS_WHATS_NEW_URL',
];

type EnvKeys = (typeof envValues)[number];

type Envs = {
  readonly [key in EnvKeys]?: string;
};

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    readonly env: {
      [key: string]: string;
    };
  }
}

/**
 * Loads the required environment variables specified in {@link envs} from the
 * env.config.js file from window.env object.
 */
export const envs: Envs = envValues.reduce<Envs>(
  (acc: Envs, environmentVariable: string) => {
    if (window.env[environmentVariable] === undefined) {
      // eslint-disable-next-line functional/no-throw-statements
      throw new Error(
        errorMessage.environmentVariableNotDefined(environmentVariable)
      );
    }

    return {
      ...acc,
      [environmentVariable]: window.env[environmentVariable],
    };
  },
  {}
);
